import { render, staticRenderFns } from "./ModalSwapDetail.vue?vue&type=template&id=52e4a090&scoped=true&"
import script from "./ModalSwapDetail.vue?vue&type=script&lang=js&"
export * from "./ModalSwapDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalSwapDetail.vue?vue&type=style&index=0&id=52e4a090&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4a090",
  null
  
)

export default component.exports